export default "__VITE_ASSET__B9gOqi5w__"